import React from 'react';
import FAQItem from './FAQItem';
import { FAQCategory as FAQCategoryType } from '../../types/faq';
import { colors } from '../../styles/theme';

const FAQCategory: React.FC<FAQCategoryType> = ({ title, icon: Icon, questions }) => {
  return (
    <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
      <div 
        className="px-6 py-4 border-b border-gray-100"
        style={{ backgroundColor: `${colors.primary}08` }}
      >
        <div className="flex items-center space-x-3">
          <div 
            className="w-8 h-8 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${colors.primary}15`, color: colors.primary }}
          >
            <Icon className="w-5 h-5" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        </div>
      </div>
      <div className="divide-y divide-gray-200 px-6">
        {questions.map((question, index) => (
          <FAQItem key={index} {...question} />
        ))}
      </div>
    </div>
  );
};

export default FAQCategory;